<div class="card">
    <p>Seleccione un usuario fuera de la línea y agréguelo o elimínelo de la línea seleccionada.</p>
    <p-pickList
        [source]="sourceUsuarios"
        [target]="targetUsuarios"
        [dragdrop]="false"
        [responsive]="true"
        [sourceStyle]="{ height: '30rem' }"
        [targetStyle]="{ height: '30rem' }"
        filterBy="nombre,apellido"
        sourceFilterPlaceholder="Buscar por nombre o apellido"
        targetFilterPlaceholder="Buscar por nombre o apellido"
        breakpoint="768px"
        buttonStyleClass="boton-picklist"
    >
        <ng-template let-usuario let-selected="selected" pTemplate="item">
            <div class="flex flex-wrap p-1 items-center gap-4 w-full">
                <div class="flex-1 flex flex-col">
                    <span class="font-medium text-sm">{{ usuario.nombre }} {{ usuario.apellido }}</span>
                    <span
                        [ngClass]="{
                            'text-surface-600': !selected,
                            'dark:text-surface-500': !selected,
                            'text-inherit': selected
                        }"
                    >
                    </span>
                </div>
            </div>
        </ng-template>
    </p-pickList>

    <div class="w-full pt-10 flex justify-end items-center">
    <p-button label="Guardar" (onClick)="guardar()" class="w-32" />
    <p-button label="Cancelar" (onClick)="cancelar()" class="w-32 bg-transparent ml-2 text text-primary" />
    </div>
</div>
